exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: flex;\n  min-width: 40px;\n}\n\n.study-title {\n  align-self: center;\n  min-width: 40px;\n  letter-spacing: 0px;\n}\n\n.header-subtitle {\n  font-size: 12px;\n  line-height: 14px;\n  opacity: 0.8;\n  margin-top: 4px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n@media screen and (max-width: 699px) {\n  .header-link {\n    display: none;\n  }\n}\n\n", ""]);

// exports
